(function (process,global,Buffer,__argument0,__argument1,__argument2,__argument3,__filename,__dirname){
// ------------------------------------
//
// Theme
//
// ------------------------------------

(function($) {

    if (typeof window.Theme == 'undefined') window.Theme = {};

    Theme = {

        settings: {},

        /*
         * Theme init
         */

        init: function() {

            // Init

            this.sliders();

            // Modal
            this.modal();

            // Toggle
            this.toggle();

            // Mobile Menu
            this.mobile();

            // Stupid Ninja Form Wrapper Fix
            this.ninjaFix();

            $('.js-toggle').on('click', function() {

                if ($(this).not('.arrow')) {
                    $(this).toggleClass('active');
                }

                if ($(this).is('.arrow')) {
                    $('.expand').removeClass('active');
                    $(this).addClass('active').removeClass('arrow');
                }

                if ($(this).is('.expand')) {
                    $('.ham').addClass('arrow');
                }
            });

        },

        // ------------------------------------
        // Ninja Form Wrapper Fix
        // ------------------------------------

        ninjaFix: function(){

            setTimeout(function(){ $('.nf-field-container.-half').parent().addClass('-half'); }, 2000);

        },


        // ------------------------------------
        // Sliders
        // ------------------------------------

        sliders: function() {

            $('.js-featured').each(function() {

                var $slider 	= $(this);
                var toShow      = $slider.find('.image').length;
                var $nav 		= $slider.next('.feature-nav');

                $slider.slick({
                    speed: 400,
                    arrows: false,
					slidesToScroll: 1,
					slidesToShow: 1,
                    // autoplay: true,
                    // autoplaySpeed: 4000,
                    cssEase: 'cubic-bezier(.5,0,0,1)',
                    speed: 800,
					asNavFor: $nav
                });

                $nav.slick({
                    slidesToShow: toShow,
				 	slidesToScroll: 1,
                    asNavFor: $slider,
                    arrows: false,
                    infinite: false,
                    focusOnSelect: true
                });

                // On before slide change match active thumbnail to current slide
                $slider.on('beforeChange', function(event, slick, currentSlide, nextSlide) {
                    var slideNumber = nextSlide;
                    $nav.find('.item').removeClass('slick-active');
                    $nav.find('.item').eq(slideNumber).addClass('slick-active');
                    $('.item').css('pointer-events','none');

                    setTimeout(function() {
                        $('.item').css('pointer-events','all');
                    },900);
                });

                $slider.on('afterChange', function(event, slick, currentSlide) {
                    var slide = currentSlide + 1;
                    var $content = $(this).parents('.row-content');

                    $content.find('.slide-content').fadeOut();
					$content.find('[data-slide="'+slide+'"]').delay(400).fadeIn();
                });

                // $slider.parent('.image-con').find('.item').click(function() {
                //     $slider.slickGoTo($(this).data('slide'));
                // });

            });

        },


        // ------------------------------------
        // Mobile Menu
        // ------------------------------------

        mobile: function() {

            $('nav .menu-header > .menu-item-has-children > a').after('<button class="expand js-toggle"></button>');

        },


        // ------------------------------------
        // Toggle
        // ------------------------------------

        toggle: function(e) {

            // $('.js-toggle').on('click', function() {
            //     console.log('toggle');
            //     $(this).toggleClass('active');
            // });

        },


        // ------------------------------------
        // Video Modal
        // ------------------------------------

        modal: function(){

            // Everything to do with the modal

            $('.js-video, .js-close').on('click', function() {
                Theme.video($(this));
            });

        },


        // ------------------------------------
        // video
        // ------------------------------------

        video: function($this) {

            if( $this.hasClass('active') || $this.is('.js-close') )
                Theme.close($this,$this.parents('.modal'));
            else
                Theme.open( $this, $('[data-video=' + $this.attr('id') + ']') );

        },

        close: function($this,$modal){

            // Remove Src from iframe
            $this.parents('.video').find('.active').removeClass('active');
            var $frame = $modal.removeClass('active').find('iframe');

            setTimeout (function() {
                $frame.attr('src','');
            }, 400);
        },

        open: function($this,$modal){

            // Add Source to Iframe
            $modal.addClass('active');
            var $frame = $modal.find('iframe');
            var src = $modal.attr('data-src');

            $frame.attr('src',src);

        },
    };


    module.exports = Theme;

})(jQuery);

}).call(this,require("rH1JPG"),typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],"/modules/theme.js","/modules")